// extracted by mini-css-extract-plugin
export default {"pickerContainer":"SharePointPickerIframeModal__pickerContainer___U7Wcd","loaderContainer":"SharePointPickerIframeModal__loaderContainer___ozEP8"};